import React from "react";
import { ReactComponent as HelpCircle } from "../assets/icons/NeedHelp.svg";
import { ReactComponent as Private } from "../assets/icons/SecurePrivate.svg";
import { useScreenTransition } from "../Hooks/useScreenTransition";
import "./SecureAndPrivate.css";
import { getDue } from "../Data/Functions";
import { Clock } from "react-feather";

const SecureAndPrivate = ({nomargin, hideNeedHelp = false, order, pagesCount, certified, expedited, expeditedPlus}) => {
    const { transitionTo } = useScreenTransition();
    return (
      <div
        className="mainOrderPageSecureAndPrivate"  style={nomargin ? { marginLeft: 0 } : null}
      >
        {order && (order.pagesCount || pagesCount) && (order.certified || certified) && 
        <div className="mainOrderPageSecureAndPrivateBlock">
          <div className="mainSecureAndPrivateHead">
            <Clock className="mainSecureAndPrivateHeadIcon" color='#686f7b'/>
            {/* <Private className="mainSecureAndPrivateHeadIcon" /> */}
            <span className="mainSecureAndPrivateHeadTitle">
              {getDue(false,order,pagesCount, certified, expedited, expeditedPlus)} est. turnaround
            </span>
          </div>
          <div className="mainSecureAndPrivateText" style={{ marginLeft: 25 }}>
            This is an estimate to deliver the digital copy based on the current order information you've provided.
          </div>
      </div> } 
        <div className="mainOrderPageSecureAndPrivateBlock">
          <div className="mainSecureAndPrivateHead">
            <Private className="mainSecureAndPrivateHeadIcon" />
            <span className="mainSecureAndPrivateHeadTitle">
              Secure and Private
            </span>
          </div>
          <div className="mainSecureAndPrivateText" style={{ marginLeft: 25 }}>
            All data processed by our site, including uploaded files, is
            encrypted. Only essential staff with signed NDAs can access your
            information.
          </div>
        </div>
  
        {!hideNeedHelp && <div className="mainOrderPageSecureAndPrivateBlock">
          <div className="mainSecureAndPrivateHead">
            <HelpCircle className="mainSecureAndPrivateHeadIcon" />
            <span className="mainSecureAndPrivateHeadTitle">Need help</span>
          </div>
        </div>}
  
        <div className="mainSecureAndPrivateText" style={{ marginLeft: 25 }}>
          <span
            className="mainContactUs"
            onClick={(e) => transitionTo("/contact", e)}
          >
            Contact us{" "}
          </span>
          and we will create the order on your behalf.
        </div>
      </div>
    );
}

export default SecureAndPrivate